const defaultSourceTrimRoute = "/cotizador3/source-trim-lumo";
const rawSourceTrimRoute = (process.env.REACT_APP_SOURCE_TRIM_ROUTE || "").trim();
const sourceTrimRouteValue = rawSourceTrimRoute || defaultSourceTrimRoute;

module.exports = {
	api: process.env.REACT_APP_API,
	url: process.env.REACT_APP_URL,
	prod: process.env.REACT_APP_ENV === "production",
	rodac_api: process.env.REACT_APP_RODAC_API,
	rodac_username: process.env.REACT_APP_RODAC_USERNAME,
	rodac_password: process.env.REACT_APP_RODAC_PASSWORD,
	buro_token_api: process.env.REACT_APP_BURO_TOKEN_API,
	buro_client_id: process.env.REACT_APP_BURO_CLIENT_ID,
	buro_client_secret: process.env.REACT_APP_BURO_CLIENT_SECRET,
	buro_informe_api: process.env.REACT_APP_BURO_INFORME_API,
	// Si true, usa la nueva fórmula donde input usuario = Total Pago Inicial.
	// Acepta ambos nombres por compatibilidad (los .env históricos usaban REACT_APP_COTIZADOR_V2).
	usarCotizadorV2: process.env.REACT_APP_USAR_COTIZADOR_V2 === "true" || process.env.REACT_APP_COTIZADOR_V2 === "true",
	sourceTrimAccessEnabled: process.env.REACT_APP_SOURCE_TRIM_ACCESS_ENABLED !== "false",
	sourceTrimRoute: sourceTrimRouteValue.startsWith("/") ? sourceTrimRouteValue : `/${sourceTrimRouteValue}`,
};